

















import { UserModel } from "../../apis";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppButtonSaveCancelShipment extends Vue {

  addShipment() {
    this.$store.commit("ADD_SHIPMENT_CLICK");
  }

  onCancelAdd() {
    if ('from' in this.$route.query) {
      return this.$router.push({ name: "shipment" });
    }
    return this.$router.push({
      name: "shipment-detail",
      params: { id: this.$route.params.id },
      query: { t: "" + new Date().getTime() },
    });
  }

}
